import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { AuthServiceService } from './auth-service.service';

@Injectable({
  providedIn: 'root'
})
export class CommonServiceService {

  private baseUrl: string = environment.apiUrl;
  rows: any[] = [];
  Users: any[] = [];
  Material: any[] = [];
  Service: any[] = [];
  Asset: any[] = [];
  BOM: any[] = [];
  Vendor: any[] = [];
  Customer: any[] = [];
  MetaData: any[] = [];
  Datacleasning: any[] = [];
  Settings: any[] = [];
  LOV: any[] = [];
  Tools : any[] = [];
  Admin: any[] = [];

  constructor(public http :HttpClient,private authService: AuthServiceService,) { }

  preventNonNumeric(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  restrictSpecialChars(event: KeyboardEvent) {
    const regex = /^[a-zA-Z0-9 ]+$/; // Allow only letters, numbers, and spaces
    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  }

  allowTextOnly(event: KeyboardEvent) {
    const regex = /^[a-zA-Z\s]+$/; // Allow only letters and spaces
    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  }


  allowTextAndNumberOnly(event: KeyboardEvent) {
    const regex = /^[a-zA-Z0-9\s]+$/; // Letters, numbers, and spaces
    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  }
  

allowNumbersOnly(event: KeyboardEvent) {
  const regex = /^[0-9]+$/; // Only numbers
  if (!regex.test(event.key)) {
    event.preventDefault();
  }
}


restrictSpace(event: KeyboardEvent): boolean {
  if (event.key === ' ') {
    event.preventDefault();
    return false;
  }
  return true;
}



  saveFile(data: Blob, fileName: string) {
    const blob = new Blob([data], { type: data.type });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  loadpage(userId: string) {
    const params = new HttpParams().set('UserId', userId);

    this.http.get<any>(this.baseUrl + '/api/Getpage', { params }).subscribe({
      next: (response) => {
        this.rows = response;
        this.authService.pageList = response;
        localStorage.setItem('pageList', JSON.stringify(this.rows));
         this.categorizeData();
      },
      error: (error) => {
        console.log(error);
        if(error.status == 401){
          this.authService.logout();
        }
      },
    });
  }

    categorizeData(): void {
    this.Users = [];
    this.Material = [];
    this.Service = [];
    this.Asset = [];
    this.BOM = [];
    this.Vendor = [];
    this.Customer = [];
    this.Datacleasning = [];
    this.MetaData = [];
    this.Settings = [];
    this.LOV = [];
    this.Tools = [];
    this.Admin = [];

    this.rows.forEach((item) => {
      switch (item.Module) {
        case 'User':
          this.Users.push(item);
          break;
        case 'Material':
          this.Material.push(item);
          break;
        case 'Service':
          this.Service.push(item);
          break;
        case 'Asset':
          this.Asset.push(item);
          break;
        case 'BOM':
          this.BOM.push(item);
          break;
        case 'Vendor':
          this.Vendor.push(item);
          break;
        case 'Customer':
          this.Customer.push(item);
          break;
        case 'Datacleasning':
          this.Datacleasning.push(item);
          break;
        case 'Admin':
          this.Admin.push(item);
          break;
        case 'MetaData':
          this.MetaData.push(item);
          break;
        case 'LOV':
          this.LOV.push(item);
          break;
        case 'Settings':
          this.Settings.push(item);
          break;

        case 'Tools':
          this.Tools.push(item);
          break;

        default:
          console.warn(`Unknown Mainmenu: ${item.Module}`);
          break;
      }
    });
  }

  getSequenceType(){
    this.http.get<any>(this.baseUrl + '/api/Catalogue/getSequenceType').subscribe({
      next: (response) => { 
        localStorage.setItem('sequenceType', JSON.stringify(response));
      },
      error: (error) => {
        console.log(error);
        if(error.status == 401){
          this.authService.logout();
        }
      }
  })

  
}
}
